import {
    FETCH_ALL_ROLES,
    FETCH_ALL_ACTIVE_SCOPES
} from '../actions/actionTypes';

const initialState = {
    rolesList:       [],
    rolesMeta:       {},
    allActiveScopes: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_ROLES:
            return {
                ...state,
                rolesList: [...action.payload.data],
                rolesMeta: {...action.payload.meta}
            };
        case FETCH_ALL_ACTIVE_SCOPES:
            return {
                ...state,
                allActiveScopes: [...action.payload]            
            };
        default:
            return state;
    }
};
